import React, { Component } from "react"
import AnimatedCheckmarkButton from "../common/animatedCheckmarkButton"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"
import { trackTravelPlannerParkingSearch } from "../../../helpers/tracking"
import Svg from "../../../shared/_svgs/svg"
import priceFormatter from "../../helpers/priceFormatter"
import { parkingState } from "../../zustand/parkingState"

class ParkingProductHighlightElementNew extends Component {
  static defaultProps = {
    image: "/static/airline-sales-hero.png",
    name: "Economy",
    description: "Få en let udvendig rengøring af din bil. Bilen bliver vasket og aftørret i hånden.",
    price: "245 DKK",
    grid_classes: "grid-item col--12 col-xs--4",
    buttonText: "Tilføj",
    buttonOnClick: undefined,
    buttonClass: "",
    modalTemplate: "carServiceModal",
    noOriginalPrice: true,
    modifier_class: "parking-product-highlight--stagger",
    type: "",
    typeText: "",
    modalButtonText: "",
    modalButtonOnClick: undefined,
    labelPrice: "",
  }

  state = {}

  handleTrackingClick = (callback, eventAction, eventLabel) => {
    tracking.trackParkingFlowClick(eventAction, eventLabel)
    callback()
  }

  readMoreTrackingHandler = (isExtraService) => {
    if (isExtraService) {
      this.handleTrackingClick(this.props.modalButtonOnClick, "extra services", `read more - ${this.props.product.name}`)
    } else if (this.props.flightId) {
      trackTravelPlannerParkingSearch(
        "track-event",
        "product stagger",
        "read more",
        this.props.flightId,
        this.props.arrivalDate,
        this.props.departureDate,
      )
      this.props.modalButtonOnClick()
    } else {
      this.handleTrackingClick(this.props.modalButtonOnClick, "product stagger", "read more")
    }
  }

  reserveTrackingHandler = (isExtraService) => {
    if (isExtraService) {
      this.handleTrackingClick(
        this.props.isSelectedProduct ? this.props.buttonOnClickActiveProduct : this.props.buttonOnClick,
        "extra services",
        this.props.isSelectedProduct ? `remove - ${this.props.product.name}` : `add - ${this.props.product.name}`,
      )
    } else if (this.props.flightId) {
      trackTravelPlannerParkingSearch(
        "track-event",
        "product stagger",
        "reserve",
        this.props.flightId,
        this.props.arrivalDate,
        this.props.departureDate,
      )
      this.props.buttonOnClick()
    } else {
      this.handleTrackingClick(this.props.buttonOnClick, "product stagger", "reserve")
    }
  }

  handleMapOnClick = async () => {
    await this.props.mapOnClick()
    parkingState.setState({
      isParkingProductMapModalActive: true,
      isParkingSpecialProductActive: false,
      isParkingDetailsModalActive: false,
    })
  }

  render() {
    const {
      type,
      typeText,
      icon,
      image,
      name,
      location,
      ribbonText,
      description,
      usp,
      modalTemplate,
      labelPrice,
      price,
      urgency,
      buttonOnClick,
      priceSub,
      noOriginalPrice,
      originalPrice,
      buttonText,
      modalButtonText,
      modifier_class,
      grid_classes,
      result,
      isExtraService,
      isLoggedIn,
      spacer,
      product,
      globals,
    } = this.props

    const highlightModalButtonText = config.get("textKeys.parkingList.listElement.readMore") || "Læs Mere"
    const viewOnMap = config.get("textKeys.parkingList.detailsModal.map") || "Se på kort"

    const textKeys = config.get("textKeys.parkingList.listElement") || {}
    const extraServicesElementTextKeys = config.get("textKeys.extraServices.element") || {}
    const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner

    let colorStyle = {}
    if (result?.thirdPartyPromoLabelColorCode && !affiliateCheck && !(result.originalPrice > result.totalPrice && globals.promotionName)) {
      colorStyle = { backgroundColor: result.thirdPartyPromoLabelColorCode }
    }

    return (
      <div className={`parking-product-highlight-new ${modifier_class} ${grid_classes} ${spacer}`}>
        {ribbonText && ribbonText !== "" ? (
          <span className="angled-ribbon angled-ribbon--dynamic">
            <span className="angled-ribbon__inner" style={colorStyle}>
              {ribbonText}
            </span>
          </span>
        ) : (
          ""
        )}
        {type ? (
          <div className={`parking-product-highlight__type parking-product-highlight__type--${type}`}>
            <span>{typeText}</span>
          </div>
        ) : (
          ""
        )}

        <div className="parking-product-highlight__inner">
          {image ? (
            <div className="parking-product-highlight__image">
              <img src={image} />
            </div>
          ) : (
            ""
          )}

          <div className="parking-product-highlight__name">
            <h4>
              {name}

              {location ? <span> - {location}</span> : ""}
            </h4>

            {isExtraService ? <span dangerouslySetInnerHTML={{ __html: description }}></span> : ""}
          </div>

          <div className="parking-product-highlight__price">
            <span className="parking-product-highlight__label-price">{labelPrice}</span>
            <span className="few-spots">{urgency ? textKeys.fewSpots || "Få pladser online" : ""}</span>
            {priceFormatter(result?.showMemberPrice ? result.memberPrice : price, true)} <span>DKK</span>
            {priceSub ? <small>{priceSub}</small> : ""}
            {result?.showMemberPrice ? <span className="parking-product-highlight__label-price">{textKeys.memberPrice || "Medlemspris"}</span> : ""}
            {result?.showMemberPrice ? (
              <p>
                {textKeys.nonMemberPrice || "Ikke medlem"} <em className={isLoggedIn ? "line-through" : ""}> {priceFormatter(result.totalPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showPayOnFootPrice ? (
              <p>
                {textKeys.normalOnlinePrice || "Normal onlinepris: "}
                <em className={"line-through"}>{priceFormatter(result.payOnFootPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showOriginalPrice ? (
              <p>
                {textKeys.previousPrice || "Førpris: "}
                <em className={"line-through"}>{priceFormatter(result.originalPrice)}</em>
              </p>
            ) : (
              ""
            )}
            {result?.showDriveInPrice ? (
              <p>
                {textKeys.drivePrice || "Drive in-pris: "}
                <em className={""}>{priceFormatter(result.barrierTariff)}</em>
              </p>
            ) : (
              ""
            )}
          </div>

          <div className="parking-product-highlight__button">
            {this.props.animateButton ? (
              <AnimatedCheckmarkButton
                buttonText={isExtraService && this.props.isSelectedProduct ? extraServicesElementTextKeys.remove || "Fjern" : buttonText}
                onClickHandler={() => this.reserveTrackingHandler(isExtraService)}
                isSelected={this.props.isSelectedProduct}
                buttonClass={this.props.isSelectedProduct ? "button--negative" : ""}
              />
            ) : (
              <button
                id={this.props.buyButtonId}
                className={`button button--small button--general ${this.props.buttonClass} ${this.props.isSelectedProduct ? "button--negative" : ""}`}
                onClick={() => {
                  this.reserveTrackingHandler(isExtraService), parkingState.setState({ modalOpenerId: this.props.buyButtonId })
                }}
                aria-label={
                  this.props.result.memberPrice > 0
                    ? `${buttonText} ${this.props.lotCode} ${this.props.location} - ${textKeys.memberPrice}: ${this.props.result.memberPrice} DKK, ${textKeys.nonMemberPrice}: ${this.props.price} DKK}`
                    : `${buttonText} ${this.props.lotCode} ${this.props.location} - ${this.props.price} DKK}`
                }
              >
                <span className="text">
                  {isExtraService && this.props.isSelectedProduct ? extraServicesElementTextKeys.remove || "Fjern" : buttonText}
                </span>
              </button>
            )}
          </div>
          {!isExtraService && usp && usp.bullets ? (
            <div className="parking-product-highlight__usp">
              <ul>
                {usp.bullets.map((u, index) => (
                  <li key={index}>
                    <Svg isDecorative={true} iconName={"checkmark2"} renderContainer={false} />
                    {u}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            ""
          )}

          <div className="link-wrapper">
            <button
              id={this.props.mapButtonId}
              className="button button--link button--link--significant has-icon"
              onClick={() => {
                this.handleMapOnClick(), parkingState.setState({ modalOpenerId: this.props.mapButtonId })
              }}
            >
              <Svg isDecorative={true} iconName={"pin2"} />
              <span className="text">{viewOnMap}</span>
            </button>
            {highlightModalButtonText ? (
              <div className="parking-product-highlight__readmore">
                <button
                  id={this.props.readMoreButtonId}
                  className="link js--open-modal"
                  onClick={() => {
                    this.readMoreTrackingHandler(isExtraService), parkingState.setState({ modalOpenerId: this.props.readMoreButtonId })
                  }}
                >
                  {highlightModalButtonText}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    )
  }
}
export default ParkingProductHighlightElementNew
